import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetCenterDetailResponse } from '@/api/type/types';

interface getCenterDetailProps {
  centerId: string;
}
export const getCenterDetail = async ({ centerId }: getCenterDetailProps) => {
  const res = await api.get<ApiResponseType<GetCenterDetailResponse>>(
    `/api/web/admins/partners/centers/${centerId}`
  );
  return res.data;
};
